import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { NAV_LINKS, BRAND } from "@/lib/constants";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur supports-[backdrop-filter]:bg-[var(--ovi-cream)]/75 bg-[var(--ovi-cream)]/95 border-b border-[var(--ovi-border)]"
      data-testid="main-navbar"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="inline-flex items-center leading-none transition-opacity hover:opacity-80"
          data-testid="nav-ovi-logo"
          aria-label={`${BRAND.name} — Home`}
        >
          <img
            src="/ovi-nav-icon.png"
            alt="OVI"
            className="h-10 w-auto"
            width="120"
            height="40"
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              data-testid={link.testid}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-[var(--ovi-terracotta)] ${
                  isActive ? "text-[var(--ovi-terracotta)]" : "text-[var(--ovi-indigo)]"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        {/* Mobile nav */}
        <div className="md:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button
                aria-label="Open menu"
                data-testid="nav-mobile-menu-button"
                className="p-2 rounded-md text-[var(--ovi-indigo)] hover:bg-[var(--ovi-cream-2)] transition-colors"
              >
                <Menu className="h-6 w-6" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[280px] bg-[var(--ovi-cream)] border-l border-[var(--ovi-border)]">
              <SheetTitle className="sr-only">Navigation</SheetTitle>
              <div className="flex items-center justify-between mb-8">
                <img
                  src="/ovi-nav-icon.png"
                  alt="OVI"
                  className="h-8 w-auto"
                />
                <button
                  aria-label="Close menu"
                  onClick={() => setOpen(false)}
                  className="p-2 rounded-md text-[var(--ovi-indigo)]"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
              <nav className="flex flex-col gap-1" aria-label="Mobile primary">
                {NAV_LINKS.map((link) => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    end={link.to === "/"}
                    onClick={() => setOpen(false)}
                    data-testid={`mobile-${link.testid}`}
                    className={({ isActive }) =>
                      `px-3 py-3 rounded-md text-base font-medium transition-colors ${
                        isActive
                          ? "text-[var(--ovi-terracotta)] bg-[var(--ovi-cream-2)]"
                          : "text-[var(--ovi-indigo)] hover:bg-[var(--ovi-cream-2)]"
                      }`
                    }
                  >
                    {link.label}
                  </NavLink>
                ))}
              </nav>
              <div className="mt-10 pt-6 border-t border-[var(--ovi-border)] text-xs text-[var(--ovi-muted-ink)]">
                Born in Solapur, Built for India.
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
